<template>
  <div
    class="main_bg"
    style="
      background-image: url('img/room_bg.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    "
  >
    <div class="title_top">
      <back-nav-last-page
        :icon="'img/backw.png'"
        :textColor="'#fff'"
        :backColor="'transparent'"
        :rightbg="'img/searchw.png'"
      />
    </div>
    <div
      class="my_invite_top display_flex justify-content_flex-justify margin-top"
    >
      <div
        class="mynav display_flex flex-direction_column align-items_center"
        :style="{ backgroundImage: 'url(img/myBg1.png)' }"
        @click="typeChange(1)"
      >
        <span style="color: #fff" class="margin-top-xs">{{
          indexData.invite_num
        }}</span>
        <p style="color: #fff">我的邀请</p>
      </div>
      <div
        class="mynav display_flex flex-direction_column align-items_center margin-lr-sm"
        :style="{ backgroundImage: 'url(img/myBg2.png)' }"
        @click="typeChange(2)"
      >
        <span style="color: #fff" class="margin-top-xs">{{
          indexData.effective_invite_num
        }}</span>
        <p style="color: #fff">有效人数</p>
      </div>
      <!-- <div class="mynav display_flex flex-direction_column align-items_center"
          :style="{ backgroundImage: 'url(img/myBg3.png)' }">
          <div class="display_flex align-items_center margin-top">
            <span class="margin-left-xs" style="margin: 0;color: #111;">{{ send_money }}</span>
            <img src="img/bi.png" alt="">
          </div>
          <p style="color: #fff;">下级累计赠送</p>

        </div> -->
    </div>

    <div
      class="display_flex justify-content_flex-justify align-items_center margin-bottom-xl padding-lr-lg margin-top"
      style="position: relative"
    >
      <p style="color: #111" class="my_title">排序规则</p>
      <div class="my_sort display_flex align-items_center" @click="sortClick">
        <p style="color: #fff !important" class="margin-right-xs">
          {{ sortData[sortType].name }}
        </p>
        <img src="img/game/sort.png" alt="" />
      </div>
      <div class="sort_box padding-tb-sm" v-if="sortDisplay">
        <p
          :class="{ sort_cur: sortData[sortType].type == index }"
          v-for="(item, index) in sortData"
          :key="index"
          @click="sortChange(index)"
        >
          {{ item.name }}
        </p>
      </div>
    </div>

    <div class="padding-lr-sm">
      <!--  @click="goDetail(item)" -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="fetchData"
      >
        <div
          class="myItem margin-bottom-sm"
          v-for="(item, index) in listData"
          style="background-image: url('img/invite_item.png')"
          :key="index"
        >
          <img
            class="is_effect"
            src="img/is_effect.png"
            alt=""
            v-if="item.is_effective == 1"
          />
          <div
            class="my_itemTop display_flex justify-content_flex-justify align-items_center padding-lr-sm"
          >
            <div class="display_flex align-items_flex-end top">
              <div
                style="
                  width: 50%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                "
              >
                <div
                  class="my-order margin-right-sm"
                  style="
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <img
                    v-if="index < 3"
                    class="my-num"
                    :src="'img/' + (index + 1) + '.png'"
                    alt=""
                  />
                  <span style="color: #fff" v-else>{{ index + 1 }}</span>
                </div>
                <div>
                  <p
                    style="
                      color: #fff;
                      font-size: 16px;
                      display: flex;
                      align-items: center;
                    "
                  >
                    {{ item.nickname }}
                  </p>
                  <div class="my_id" style="color: #999999">
                    ID:{{ item.uid }}
                  </div>
                </div>
              </div>
              <!-- <div class="margin-top-sm top-right">{{ item.created_at }}</div> -->
              <div class="my_content">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    height: 100%;
                  "
                >
                  <div style="font-size: 12px; color: #fff">邀请人数</div>
                  <div style="color: #fff" class="font_size_30">
                    {{ item.invite_sum }}
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    height: 100%;
                  "
                >
                  <div style="font-size: 12px; color: #fff">累计充值</div>
                  <div style="color: #fff" class="font_size_30">
                    {{ item.total_recharge }}
                  </div>
                </div>

                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    height: 100%;
                  "
                >
                  <div style="font-size: 12px; color: #fff">有效收益</div>
                  <div style="color: #fff" class="font_size_30">
                    {{ item.total_money }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <div class="noData margin-top-xl" v-if="noData">
        <img src="img/noData.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/base.css";
import "@/assets/css/index.css";
import { myInviteDetail } from "@/api/api";
import BackNavLastPage from "@/components/backNavLastPage.vue";
export default {
  name: "myInvite",
  components: {
    BackNavLastPage,
  },
  data() {
    return {
      sortData: [
        {
          type: 0,
          name: "邀请人数优先",
        },
        // {
        //     type:1,
        //     name:'有效认证优先'
        // },
        {
          type: 2,
          name: "注册时间优先",
        },
      ],
      sortType: 0,
      sortDisplay: false,
      indexData: {},
      listData: [],
      noData: false,
      type: 1,
      loading: false,
      finished: false,
      page: 1,
      row: 20,
    };
  },
  created() {
    this.indexData = JSON.parse(this.$route.query.indexData);
  },
  methods: {
    fetchData() {
      const Params = {
        sort: this.sortType,
        type: this.type,
        page: 1,
        rows: this.row,
      };
      myInviteDetail(Params)
        .then(
          (response) => {
            this.listData = response.data;
            this.loading = false;
            this.finished = true;
            if (response.data.length == 0) {
              this.noData = true;
            } else {
              this.noData = false;
            }
            this.sortDisplay = false;
          },
          (error) => {
            this.loading = false;
            this.finished = true;
            this.$toast.fail(error);
          }
        )
        .catch((error) => {
          this.loading = false;
          this.finished = true;
          this.$toast.fail(error);
        });
    },
    typeChange(e) {
      this.type = e;
      this.loading = true;
      this.finished = false;
      this.listData = [];
      this.page = 1;
      // this.fetchData();
    },
    sortClick() {
      this.sortDisplay = !this.sortDisplay;
    },
    sortChange(e) {
      this.sortType = e;
      this.loading = true;
      this.finished = false;
      this.listData = [];
      this.page = 1;
      // this.fetchData();
      this.sortDisplay = false;
    },
    goDetail(item) {
      this.$router.push({
        path: "/lastInvite",
        query: {
          id: item.send_user_id,
          invite_sum: item.invite_sum,
          s_send_sum: item.s_send_sum,
          nickname: item.nickname,
          effective_num: item.effective_num,
        },
      });
    },
  },
  watch: {
    $route: "fetchData",
  },
};
</script>

<style>
/* html,
body {
  background-color: #171726;
  height: 100%;
  overflow: scroll;
} */
</style>